// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".availability-settings .working-times .settings-label{margin:0}.availability-settings .working-times .settings-label.active{color:#2680eb}", ""]);
// Exports
module.exports = exports;
